const v14044 = new Uint8Array(512);
const v14045 = new Uint8Array(256);
(function () {
  let vLN1174 = 1;
  for (let vLN02590 = 0; vLN02590 < 255; vLN02590++) {
    v14044[vLN02590] = vLN1174;
    v14045[vLN1174] = vLN02590;
    vLN1174 <<= 1;
    if (vLN1174 & 256) {
      vLN1174 ^= 285;
    }
  }
  for (let vLN255 = 255; vLN255 < 512; vLN255++) {
    v14044[vLN255] = v14044[vLN255 - 255];
  }
})();
exports.log = function (p18257) {
  if (p18257 < 1) {
    throw new Error("log(" + p18257 + ")");
  }
  return v14045[p18257];
};
exports.exp = function (p18258) {
  return v14044[p18258];
};
exports.mul = function (p18259, p18260) {
  if (p18259 === 0 || p18260 === 0) {
    return 0;
  } else {
    return v14044[v14045[p18259] + v14045[p18260]];
  }
};